// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Webpack 전용 함수

const images = require.context(
  '../public/images/og',
  false,
  /\.(png|jpe?g|webp)$/
);

images.keys().forEach((path: string) => {
  const img = images(path);
  console.log(`[OG preload] ${path}: ${img?.src}`);
});
